module.exports = __webpack_public_path__ + "static/media/foodprint_app5.489171e5.jpg";